export default __webpack_public_path__ + "static/media/iso_13485.1a9c55ee.jpg";